import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchShipToOrders, fetchSalesOrderDetail } from '../../actions/shipToOrders_actions';

import ShipToOrders from '../../components/Sales/shipToOrders';

const shipToOrders = reduxForm({
  form: 'shipToOrders',
  destroyOnUnmount: false,
})(ShipToOrders);

function mapStateToProps(state) {
  return {
    currentSalesOrder: state.shipToOrders.currentSalesOrder,
    shipToOrders: state.shipToOrders.all,
    isLoading: state.shipToOrders.isLoading,
    error: state.shipToOrders.error,
    salesOrderDetail: state.shipToOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.shipToOrders.detailIsLoading,
    salesOrderError: state.shipToOrders.detailError,
    salesOrdersFilter: state.shipToOrders.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    msoTotalPages: state.shipToOrders.msoTotalPages,

    requestingShippingList: state.shipToOrders.requestingShippingList,
    shippingListPDF: state.shipToOrders.shippingListPDF,

    requestingPickingList: state.shipToOrders.requestingPickingList,
    pickingListPDF: state.shipToOrders.pickingListPDF,

    requestingPackingList: state.shipToOrders.requestingPackingList,
    packingListPDF: state.shipToOrders.packingListPDF,

    requestingSalesOrderPDF: state.shipToOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.shipToOrders.salesOrderPDF,

    requestingBolIdPDF: state.shipToOrders.requestingBolIdPDF,
    bolIdPDF: state.shipToOrders.bolIdPDF,
    requestingBolWithoutLogPDF: state.shipToOrders.requestingBolWithoutLogPDF,
    bolWithoutLogPDF: state.shipToOrders.bolWithoutLogPDF,
    requestingBolLabel: state.shipToOrders.requestingBolLabel,
    bolLabel: state.shipToOrders.bolLabel,
    requestingBolFbaPDF: state.shipToOrders.requestingBolFbaPDF,
    bolFbaPDF: state.shipToOrders.bolFbaPDF,
    bolAddress: state.shipToOrders.bolAddress,
    quoteLoading: state.shipToOrders.quoteLoading,
  };
}

export default connect(mapStateToProps, {
  fetchShipToOrders,
  fetchSalesOrderDetail,
})(shipToOrders);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/shipToOrders.jsx